import * as actionsTypes from "./actionTypes";

const getEntityList = filter => ({
    type: actionsTypes.GET_ENTITY_LIST_REQUEST,
    filter
});

const searchEntities = searchFields => ({
    type: actionsTypes.ENTITY_SEARCH_REQUEST,
    searchFields
})

const getEntityData = entityId => ({
    type: actionsTypes.GET_ENTITY_REQUEST,
    entityId
})

const createEntity = entityData => ({
    type: actionsTypes.CREATE_ENTITY_REQUEST,
    entityData
});

const editEntity = (entityId, entityData) => ({
    type: actionsTypes.EDIT_ENTITY_REQUEST,
    entityId,
    entityData
});

const deleteEntity = entityId => ({
    type: actionsTypes.DELETE_ENTITY_REQUEST,
    entityId
});

const resetEntitiesForm = () => ({
    type: actionsTypes.RESET_ENTITIES_FORM
})

export default {
    getEntityList,
    searchEntities,
    getEntityData,
    createEntity,
    editEntity,
    deleteEntity,
    resetEntitiesForm
}